import { render, staticRenderFns } from "./freeDelivery.vue?vue&type=template&id=a67a644c&scoped=true"
import script from "./freeDelivery.vue?vue&type=script&lang=js"
export * from "./freeDelivery.vue?vue&type=script&lang=js"
import style0 from "./freeDelivery.vue?vue&type=style&index=0&id=a67a644c&lang=css"
import style1 from "./freeDelivery.vue?vue&type=style&index=1&id=a67a644c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67a644c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a67a644c')) {
      api.createRecord('a67a644c', component.options)
    } else {
      api.reload('a67a644c', component.options)
    }
    module.hot.accept("./freeDelivery.vue?vue&type=template&id=a67a644c&scoped=true", function () {
      api.rerender('a67a644c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowShopManagement/components/freeDelivery.vue"
export default component.exports